import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice"
import moviesReducer from "./movieSlice"
import GPTReducer from "./GPTSlice"
import configReducer from "./configSlice"
const appStore = configureStore(
    {
        reducer:{
            user: userReducer,
            movies: moviesReducer,
            gpt: GPTReducer,
            config: configReducer
        }
    }
) 

export default appStore